import { render } from "./EmailMange.vue?vue&type=template&id=2c2353c6&scoped=true"
import script from "./EmailMange.vue?vue&type=script&lang=js"
export * from "./EmailMange.vue?vue&type=script&lang=js"

import "./EmailMange.vue?vue&type=style&index=0&id=2c2353c6&lang=scss&scoped=true"
import "./EmailMange.vue?vue&type=style&index=1&id=2c2353c6&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2353c6"]])

export default __exports__